import React from "react";
import { L99BCard } from "./LegoL99DData";

/**
 * Data-driven L99E lego.
 *
 * The 3-up sibling of LegoL99DData: emits the EXACT same markup/class-names as
 * the hand-authored L99E lego (`lego l099E > triLegoContainer > [lego l099B ...]`),
 * reusing the same L99BCard as L99D so the two grids can't drift apart.
 *
 * Card shape: { title, pdf, thumb, description? }
 */
function LegoL99EData({ cards = [], legoMargin = "" }) {
  return (
    <div className={`lego l099E ${legoMargin}`.trim()}>
      <div className="triLegoContainer">
        {cards.map((card, i) => (
          <L99BCard key={card.pdf || i} {...card} />
        ))}
      </div>
    </div>
  );
}

export default LegoL99EData;
